<template>
    <div class="container">
        <h2 class="text-center"><i class="fa fa-check-circle-o"></i> My Favorite Sitters</h2>
    
    <div v-if="!loading">
       <div class="col-sm-12 pull-right hidden-sm hidden-xs"  v-if="favoriteSittersComp && favoriteSittersComp.length>0" v-for="(sitter, index) in favoriteSittersComp">
                <div class="card">
                <div class="sitterListbox ">
                    <div v-if="sitter.IsActive" @click="premiumSwal()" style="cursor: pointer;" class="ribbon-container">
                        <a target="_blank">Premium <i class="fa fa-paw"/></a>
                    </div>
                    <div class="profile-img">
                        <img :src="sitter.ProfilePhotoUrl" alt="" @click="viewProfile(sitter)" class="img-responsive img-rounded" style="cursor: pointer; min-width:170px; min-height:170px; border: 1px solid #c3c3c3;" height="240" width="240"></img>
                    </div>
                    <div class="profile-body ">
                        <div class="profile-body-details">
                            <h2>{{sitter.Name}}</h2>
                                
                            
                            <div class="home-details align-right">
                                <div class="homewrapper">
                                    <div data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Resident cat at home" class="home-icons" v-if="sitter.IsHasCat">
                                        <span><img src="../Sitters/images/ResidentCat.png" height="25" width="25"></img></span>

                                    </div>
                                    
                                  
                                    <div data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Resident dog at home" class="home-icons" v-if="sitter.IsHasDog">
                                        <span><img src="../Sitters/images/ResidentDog.png" height="25" width="25"></img></span>

                                    </div>
                                    <div data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Children at home" class="home-icons" v-if="sitter.IsHasChildren">
                                        <span><img src="../Sitters/images/HasChildren.png" height="25" width="25"></img></span>

                                    </div>
                                    <div data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Smoke allowed at home" class="home-icons" v-if="!sitter.IsSmokeFree">
                                        <span><img src="../Sitters/images/Smoke.png" height="25" width="25"></img></span>

                                    </div>
                                    
                                </div>
                                  
                            </div>
                            <div>
                                
                                <span style="margin-top:2px;" class="fa fa-2x favorite" v-if="isFavorite(sitter.SitterId)==true" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="top" data-content="Remove From Favorites" @click="addToFavorites(sitter)"> 
                              <i  class="fa fa-heart"/>
                            </span>

                                <span style="margin-top:2px;"  class="fa fa-2x favorite" v-else data-toggle="popover" data-trigger="hover" data-container="body" data-placement="top" data-content="Add to Favorites" @click="addToFavorites(sitter)"> 
                              <i  class="fa fa-heart-o"/>
                            </span>
                            </div>
                        </div>
                        <div class="bottom-row">
                            <div class="content">
                                <div v-if="sitter.RatingAvg">
                                    <i class="fa fa-star fa-1x inline" style="color:#ffd118; font-size:18px" v-for="n in sitter.RatingAvg" />
                                    <h6 class="text-muted inline reviews small"> &nbsp {{sitter.RatingCount}} Reviews</h6>
                               
                                </div>
                                <h6 style="padding-top:2px;margin-top:0px;"  class="text-muted"> <i class="fa fa-map-marker"></i> {{sitter.Location}}</h6> 
                                   
                                <h4 style="padding-top:0px;margin-top:0px;">{{sitter.Title}}</h4>
                                      
                                
                                <p class="text-overflow"> {{sitter.AboutMe}}</p>
                            </div>
                            
                        </div>
                         
                      
                            
                    </div>
                    
                </div>
                  <div style="padding-left:10px;padding-right:10px;" v-if="!sitter.RepeatedStays==0">
                            <hr style="margin:5px;">
                             <figure v-if="!sitter.AverageResponseTime==0" class="performance">
                             <figcaption class="small text-center"><i class="fa fa-clock-o" ></i> Response Time </figcaption>
                             <strong><p  class="small text-center">{{sitter.AverageResponseTime}}</p></strong>
                            </figure>

                             <figure  v-if="!sitter.RepeatedStays==0" class="performance">
                             <figcaption class="small text-center"><i class="fa fa-handshake-o" ></i> Repeated Bookings </figcaption>
                             <strong><p  class="small text-center">{{sitter.RepeatedStays}} times</p></strong>
                            </figure>
                            
                             <figure  class="performance pull-right">
                             <figcaption class="small text-center"><i class="fa fa-credit-card" ></i> Price Rates </figcaption>
                               <strong> <p  class="small text-center" ><span class="small">From </span> <strong style="color: #feb34f;">{{sitter.Price}}</strong><span class="small" > {{currencyComp}}</span></p></strong>
                                
                            </figure>
                        </div>
                    <button style="margin-top:10px;" @click="viewProfile(sitter)" class="btn-block btn btn-success btn-title ">Visit Profile</button>
            </div> <!--card end-->
            </div> <!--sitter col-sm-8 end-->
  
    </div>
           <div class="col-xs-12  hidden-md hidden-lg " style="padding:0px; margin:0px;" v-if="favoriteSittersComp && favoriteSittersComp.length>0" v-for="(sitter, index) in favoriteSittersComp">
                <div class="sittersListMobile">
                    <div v-if="sitter.IsActive" @click="premiumSwal()" style="cursor: pointer;" class="ribbon">Premium <i class="fa fa-paw"/></div>
                    <div class="small-border">
                    
                    <div class="media-body">
                        <div class="media-left">
                                <img :src="sitter.ProfilePhotoUrl" alt="" @click="viewProfile(sitter)" class="media-object img-responsive img-rounded" style="min-width:60px; min-height:60px; border: 1px solid #c3c3c3;" height="80" width="80"></img>
                                <div  @click="viewProfile(sitter)" style="cursor:pointer" v-if="sitter.IsOnline==true" class="rank-label-container">
                                    <span class="label label-default rank-label" > Online</span>
                                </div>
                        </div>
                        <div class="media-left head-title">
                            <h4 style="padding-bottom:0px;margin-bottom:0px;"><strong>{{sitter.Name}}</strong></h4>
                            <div v-if="sitter.RatingAvg">
                                        <i class="fa fa-star fa-1x inline" style="margin:0px;color:#ffd118; font-size:15px" v-for="n in sitter.RatingAvg" />
                                        <h5 style="padding:0px;margin:0px;font-size:15px" class="text-muted inline reviews"> &nbsp {{sitter.RatingCount}} Reviews</h5>
                            </div>
                            <h6 style="padding-top:2px;margin-top:2px" class="text-muted"> <i class="fa fa-map-marker"></i> {{sitter.Location}}</h6>
                        </div>
                        <h4 style="padding-top:5px;margin-top:5px;padding-bottom:2px;margin-bottom:2px;">{{sitter.Title}}</h4>
                        <p class="text-overflow"> {{sitter.AboutMe}}</p>
                    
                        <div class="col-xs-9" style="padding-left:0px;margin-left:0px;">
                    
                        <button @click="viewProfile(sitter)" class="btn btn-success btn-block btn-title">Visit Profile</button>
                        <button v-if="isFavorite(sitter.SitterId)==true" @click="addToFavorites(sitter)" lazy class="btn btn-info btn-block btn-title">Added to favorites <i class="fa fa-heart"/></button>
                        <button v-else @click="addToFavorites(sitter)" lazy class="btn btn-info btn-block btn-title">Add to favorites <i style="color:white" class="fa fa-heart-o"/></button>
                        
                        
                        </div>
                        <div class="col-xs-3 price-wrap">
                            <div class="pricing-head-mobile">
                                <h4><span>from</span>{{sitter.Price}}<span>{{currencyComp}}/day</span></h4>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div> <!--col-xs-12 hidden-md-->
    <div v-if="!loading && favoriteSittersComp.length==0">
      <h3 class="text-center">There are no Favorite Sitters added, please go to <a href="javascript:;" @click="goFindSitters()">Find Sitters</a> to add favorites</h3>
    </div>
    <div v-if="loading">
      <div  class="container"><div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div></div>
      </div>
    </div>
    </div>
    
</template>

<script>
import customerApi from '../../services/customerApi.js'
import store from '../../data/store.js'

const API_URL = "https://www.dupaws.com/services/"
    export default {
    name: 'favoriteSitters', 
    data() {
        return {
            favoriteSitters:'',
            loading: true
        };
    },
    methods:{
          premiumSwal: function(){
         
            swal({
                            title: 'Premium Member',
                            text: "You can contact and book Premium accounts directly without subscription or membership.",
                            type: "success",
                            confirmButtonClass: "btn-success",
                            confirmButtonText: 'Woof!',
                            allowOutsideClick: false,
                            closeOnConfirm: true,
                            },
                            function(isConfirm) {
                                return;
                            
                            });
     },
          goFindSitters(){
            this.$router.push({path: '/findsitters'})
          },
          addToFavorites: function(sitter) {
            var self = this
            customerApi.addSitterToFavorites(sitter)
            const index = self.favoriteSitters.findIndex(t => t.SitterId === sitter.SitterId);
            self.favoriteSitters.splice(index, 1)
            $(".popover").popover("hide") //workaround to hide popover on removing a favorite sitter.
            
      },
      viewProfile: function(sitter){
        this.$router.push({path:'/sitter/' + sitter.SitterId})
      },
    isFavorite: function(sitterId){   //Needs improvement, calling many times.
       var result = $.grep(store.getters.FavoriteSitters, function(e){ return e.SitterId == sitterId })
       if (result.length>0)
          return true
       else
        return false
     }
    
    },
    updated: function(){
      $('[data-toggle="popover"]').popover();
        //    $zopim(function (){
        //       $zopim.livechat.sendVisitorPath();
        //   });
    },
    mounted: function() {
        var self = this
         this.$ga.page(this.$router)      
        
        
        $.ajax({
            type: 'GET',
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
            },
            url: API_URL + "api/getFavoriteSitters",
            dataType: "json",
            crossDomain: true,
            contentType: "application/json; charset=utf-8",
            success: function(data) {
              self.loading = false
              self.favoriteSitters=data
                
            },
            error: function(data, status, error) {
                self.loading = false
            }
        })
        
    },
    computed: {
        favoriteSittersComp: function(){
            return this.favoriteSitters
        },
        currencyComp: function(){
        return store.getters.CountryData.Currency
        }
    }
    
}

</script>


<style scoped>

.performance{
    padding: 2px 4px;
    margin: 5px 5px 6px 0px;
    display: inline-block;
}


.price-wrap{
   border:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    padding:5px;
}

.small-border{
    border:1px;     border-radius: 5px;     border-style: solid;     border-color: #c7c6c6;     padding: 10px;     border-radius: 5px;
    
}



.pricing-head-mobile h4 span {
  display: block;
  font-size: 14px;
  font-style: italic;
  color: grey;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    padding-left: 0px;
}

.pricing-head-mobile h4 {
font-size: 38px;
    font-weight: 300;
    border-radius: 5px;
    text-align: center;
    color: #feb34f;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    padding-left: 0px;
  
}


.filters{
  background-color:#e5e5e5;
  padding:20px;
  border-radius:5px;
  border-style:solid;
  border: 1px;
  border-color: red;
}

.button-text{
    
    color:#4d4c4c;
    right:auto;
    padding:10px;
    font-family: 'Yanone Kaffeesatz', sans-serif;
    
}


.btn-default {
    color: rgb(6, 11, 66);
    background-color: rgba(236, 247, 253, 0.43);
    border-color: #ccc;
    text-align:left;
}

.btn-default:active:hover, .btn-default.active:hover, .open > .dropdown-toggle.btn-default:hover, .btn-default:active:focus, .btn-default.active:focus, .open > .dropdown-toggle.btn-default:focus, .btn-default:active.focus, .btn-default.active.focus, .open > .dropdown-toggle.btn-default.focus {
    color: #333;
    background-color: #adc1d3;
    border-color: #adadad;
}

.btn-default:hover, .btn-default:hover, .open > .dropdown-toggle.btn-default:hover{
    color: #333;
    background-color: rgba(217, 237, 247, 0.91);
    border-color: #adadad;
}


.btn-default:active, .btn-default.active, .open > .dropdown-toggle.btn-default {
    color: #333;
    background-color: rgba(188, 203, 217, 0.58);
    border-color: #adadad;
}






.form-border{
    background-color: white;
    padding: 12px;
    border-radius: 5px;


}



.reviews {
    margin-bottom: 0px;
    vertical-align: bottom;
    font-size: medium;
    margin-left: 0px;

}


.align-right {
  margin-left: auto;
}

.sitterListbox {
  display:flex;
  flex-wrap: wrap;
  
}

.bottom-row {
  display: flex;
  justify-content: space-between
}

.sitterListbox .profile-img {
  flex: .5;
  height:170px;
  width:170px;
}

.sitterListbox .profile-body {
  flex: 3;
  padding-left: 10px;
  flex-wrap:wrap;
  
  
  
}

.sitterListbox .profile-body .profile-body-details{
  display:flex;
  flex-wrap: nowrap;
}

.sitterListbox .profile-body .profile-body-aboutme {
  display: flex;
  
}

.homewrapper{
    
    display: flex;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);
    background-color: aliceblue;
    transition: 0.3s;
    border-radius: 8px;
    border-bottom-width: inherit;
}

.home-icons {
  padding:3px;
}

.sitterListbox .profile-body h2 {
  margin-top:0px;
  margin-bottom:0px;
}

.sitterListbox .profile-price {
  flex: 1;
  
}

.inline {
  display: inline;
  vertical-align: middle;
  padding-right: 1px;
  
}


.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}


.fa-heart-o {
  color:#848484; opacity: 0.7;
}


.favorite {
    color:#af1818; opacity: 0.7;
    padding-left:10px;
    
}

.favorite:hover {
    opacity: 1;
}

.favorite:active {
    transform: scale(1.1);
}

.card {
    /* Add shadows to create the "card" effect */
    margin-bottom: 20px;
    transition: 0.3s;
    border:1px;
    padding:10px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    
    
}



/* On mouse-over, add a deeper shadow */
.card:hover {
    box-shadow: 0 10px 16px 0 rgba(1,0,0,0.2);
    background:  aliceblue;
    opacity: 1;
    
}


.ribbon{
    width: 160px;
    height: 32px;
    font-size: 12px;
    text-align: center;
    color: #fff;
    font-weight: bold;
    box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
        background: linear-gradient(#e3a4fe 0%, #7a5a88 100%);
    transform: rotate(45deg);
    position: absolute;
    right: -42px;
    top: 20px;
    padding-top: 7px;
}

 	.ribbon-container {
				position: absolute;
				top: 55px;
				right: 0px;
				overflow: visible; /* so we can see the pseudo-elements we're going to add to the anchor */
				font-size: 14px; /* font-size and line-height must be equal so we can account for the height of the banner */
				line-height: 14px;
                border-radius: 1px;
			}
			
	.sittersListMobile{
    overflow: hidden; 
    position:relative;
}
	
			
	.ribbon-container a {
				display:block;
				padding:10px;
				position:relative; /* allows us to position our pseudo-elements properly */
				    background: linear-gradient(#e3a4fe 0%, #7a5a88 100%);
                    border-top-right-radius: 10px 10px;
                    border-bottom-left-radius: 10px 10px;

				overflow:visible;
				height:38px;
				margin-left:29px;
				color:#fff;
				text-decoration:none;
			}
			
	.ribbon-container a:after { /* this creates the "folded" part of our ribbon */
				content:""; 
				height: 0;
				width: 0;
				display:block;
				position:absolute;
				bottom:-15px;
				right:0;
				border-top: 15px solid #905AA7; 
				border-right: 15px solid transparent;
			}
			
	

</style>


// WEBPACK FOOTER //
// MyFavoriteSitters.vue?090f2e40